"use strict";

var _typeof = require("@babel/runtime-corejs3/helpers/typeof");
var _WeakMap = require("@babel/runtime-corejs3/core-js-stable/weak-map");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));
var _getOwnPropertySymbols = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols"));
var _assign = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/assign"));
var _bind = _interopRequireDefault(require("classnames/bind"));
var _react = _interopRequireWildcard(require("react"));
var _Icon = _interopRequireDefault(require("../Icon/Icon"));
var _AddChildPropsContext = require("../utils/_AddChildPropsContext");
var _MenuButtonItem = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./MenuButtonItem.css") : void 0);
function _getRequireWildcardCache(e) { if ("function" != typeof _WeakMap) return null; var r = new _WeakMap(), t = new _WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && _Object$getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? _Object$getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof _getOwnPropertySymbols.default === "function") for (var i = 0, p = (0, _getOwnPropertySymbols.default)(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
var CSS_BLOCK = 'sapcnqr-menu-button-item';
var MenuButtonCheckboxItem = /*#__PURE__*/_react.default.forwardRef(function (props, ref) {
  var addChildProps = (0, _AddChildPropsContext.useAddChildProps)();
  var _a = addChildProps ? (0, _assign.default)((0, _assign.default)({}, props), addChildProps(MenuButtonCheckboxItem, props)) : props,
    disabled = _a.disabled,
    label = _a.label,
    className = _a.className,
    checked = _a.checked,
    onClick = _a.onClick,
    hideMainMenu = _a.hideMainMenu,
    iconProps = _a.iconProps,
    size = _a.size,
    otherProps = __rest(_a, ["disabled", "label", "className", "checked", "onClick", "hideMainMenu", "iconProps", "size"]);
  var classnames = _bind.default.bind(_MenuButtonItem.default);
  var hideDelayTimer;
  (0, _react.useEffect)(function () {
    return function () {
      return clearTimeout(hideDelayTimer);
    };
  }, []);
  var handleClick = function handleClick(event) {
    // delay hiding the menu by a bit
    // to see the visual indication
    // of a successful selection
    hideDelayTimer = setTimeout(function () {
      hideMainMenu === null || hideMainMenu === void 0 ? void 0 : hideMainMenu();
    }, 250);
    onClick === null || onClick === void 0 ? void 0 : onClick(event);
  };
  var handleKeyDown = function handleKeyDown(event) {
    var _a;
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      handleClick === null || handleClick === void 0 ? void 0 : handleClick(event);
    }
    (_a = otherProps === null || otherProps === void 0 ? void 0 : otherProps.onKeyDown) === null || _a === void 0 ? void 0 : _a.call(otherProps, event);
  };
  var iconClasses = classnames(iconProps === null || iconProps === void 0 ? void 0 : iconProps.className, "".concat(CSS_BLOCK, "--selector__icon"), (0, _defineProperty2.default)({}, "".concat(CSS_BLOCK, "--selector__icon--selected"), checked));
  var icon = checked ? ( /*#__PURE__*/_react.default.createElement(_Icon.default, (0, _assign.default)({
    iconName: "check",
    ariaHidden: true
  }, iconProps, {
    className: iconClasses
  }))) : ( /*#__PURE__*/_react.default.createElement("span", {
    className: classnames("".concat(CSS_BLOCK, "__empty-icon"))
  }));
  if (disabled) {
    return /*#__PURE__*/_react.default.createElement("li", (0, _assign.default)({}, otherProps, {
      role: "menuitemcheckbox",
      "aria-checked": !!checked,
      ref: ref,
      "aria-disabled": true,
      className: classnames(className, CSS_BLOCK, (0, _defineProperty2.default)({}, "".concat(CSS_BLOCK, "--md"), size === 'md'), "".concat(CSS_BLOCK, "--disabled"))
    }), icon, label);
  }
  return /*#__PURE__*/_react.default.createElement("li", (0, _assign.default)({}, otherProps, {
    role: "menuitemcheckbox",
    "aria-checked": !!checked,
    className: classnames(className, CSS_BLOCK, "".concat(CSS_BLOCK, "__checkbox"), (0, _defineProperty2.default)({}, "".concat(CSS_BLOCK, "--md"), size === 'md')),
    tabIndex: 0,
    onClick: handleClick,
    onKeyDown: handleKeyDown,
    ref: ref
  }), icon, label);
});
MenuButtonCheckboxItem.displayName = 'MenuButtonCheckboxItem';
var _default = exports.default = MenuButtonCheckboxItem;